// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/auth/svc_authentication.proto (package com.diagnocat.auth, syntax proto3)
/* eslint-disable */

import { Empty, proto3, Timestamp } from "@bufbuild/protobuf";
import { UserConsents } from "../../model/dto_user_pb.js";
import { Organization } from "../../model/dto_organization_pb.js";
import { SharingInvitation } from "../../model/dto_sharing_pb.js";
import { OrganizationStaff } from "../../model/dto_organization_staff_pb.js";
import { AuthState, MFAStatus, OrganizationAPIKey, Permissions, Session } from "./dto_auth_pb.js";

/**
 * @generated from message com.diagnocat.auth.SignInReq
 */
export const SignInReq = proto3.makeMessageType(
  "com.diagnocat.auth.SignInReq",
  () => [
    { no: 1, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.SignUp_ByOneself_1_SendUserInfoReq
 */
export const SignUp_ByOneself_1_SendUserInfoReq = proto3.makeMessageType(
  "com.diagnocat.auth.SignUp_ByOneself_1_SendUserInfoReq",
  () => [
    { no: 1, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "PhoneNumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.SignUp_ByOneself_2_ConfirmIdentityReq
 */
export const SignUp_ByOneself_2_ConfirmIdentityReq = proto3.makeMessageType(
  "com.diagnocat.auth.SignUp_ByOneself_2_ConfirmIdentityReq",
  () => [
    { no: 1, name: "ConfirmationCode", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Action" },
    { no: 2, name: "Resend", kind: "message", T: SignUp_ByOneself_2_ConfirmIdentityReq_ResendConfirmationCode, oneof: "Action" },
  ],
);

/**
 * @generated from message com.diagnocat.auth.SignUp_ByOneself_2_ConfirmIdentityReq.ResendConfirmationCode
 */
export const SignUp_ByOneself_2_ConfirmIdentityReq_ResendConfirmationCode = proto3.makeMessageType(
  "com.diagnocat.auth.SignUp_ByOneself_2_ConfirmIdentityReq.ResendConfirmationCode",
  [],
  {localName: "SignUp_ByOneself_2_ConfirmIdentityReq_ResendConfirmationCode"},
);

/**
 * @generated from message com.diagnocat.auth.SignUp_ByOneself_3_SetPasswordReq
 */
export const SignUp_ByOneself_3_SetPasswordReq = proto3.makeMessageType(
  "com.diagnocat.auth.SignUp_ByOneself_3_SetPasswordReq",
  () => [
    { no: 1, name: "Password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "Consents", kind: "message", T: UserConsents },
    { no: 101, name: "HubspotUTK", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.auth.CheckInviteTokenReq
 */
export const CheckInviteTokenReq = proto3.makeMessageType(
  "com.diagnocat.auth.CheckInviteTokenReq",
  () => [
    { no: 1, name: "Token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.CheckInviteTokenResp
 */
export const CheckInviteTokenResp = proto3.makeMessageType(
  "com.diagnocat.auth.CheckInviteTokenResp",
  () => [
    { no: 1, name: "IsAlreadyRegistered", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 100, name: "InvitationInfo", kind: "message", T: CheckInviteTokenResp_Invitation, oneof: "Info" },
    { no: 101, name: "SignUpViaSalesmanInfo", kind: "message", T: CheckInviteTokenResp_SignUpViaSalesman, oneof: "Info" },
  ],
);

/**
 * @generated from message com.diagnocat.auth.CheckInviteTokenResp.Invitation
 */
export const CheckInviteTokenResp_Invitation = proto3.makeMessageType(
  "com.diagnocat.auth.CheckInviteTokenResp.Invitation",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
    { no: 11, name: "Sharing", kind: "message", T: SharingInvitation, oneof: "Result" },
    { no: 12, name: "OrganizationStaff", kind: "message", T: OrganizationStaff, oneof: "Result" },
  ],
  {localName: "CheckInviteTokenResp_Invitation"},
);

/**
 * @generated from message com.diagnocat.auth.CheckInviteTokenResp.SignUpViaSalesman
 */
export const CheckInviteTokenResp_SignUpViaSalesman = proto3.makeMessageType(
  "com.diagnocat.auth.CheckInviteTokenResp.SignUpViaSalesman",
  () => [
    { no: 1, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "CheckInviteTokenResp_SignUpViaSalesman"},
);

/**
 * @generated from message com.diagnocat.auth.SignUp_ViaSharedPatientReq
 */
export const SignUp_ViaSharedPatientReq = proto3.makeMessageType(
  "com.diagnocat.auth.SignUp_ViaSharedPatientReq",
  () => [
    { no: 1, name: "InviteToken", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 101, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 102, name: "Password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 103, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 104, name: "Country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 105, name: "Consents", kind: "message", T: UserConsents },
    { no: 106, name: "HubspotUTK", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.auth.SignUp_ViaSharedPatientResp
 */
export const SignUp_ViaSharedPatientResp = proto3.makeMessageType(
  "com.diagnocat.auth.SignUp_ViaSharedPatientResp",
  () => [
    { no: 1, name: "AuthState", kind: "message", T: AuthState },
    { no: 2, name: "RecipientEmail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.SignUp_ViaOrganizationInviteReq
 */
export const SignUp_ViaOrganizationInviteReq = proto3.makeMessageType(
  "com.diagnocat.auth.SignUp_ViaOrganizationInviteReq",
  () => [
    { no: 1, name: "InviteToken", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 101, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 102, name: "Password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 103, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 104, name: "Consents", kind: "message", T: UserConsents },
    { no: 105, name: "HubspotUTK", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.auth.SignUp_ViaSalesmanInviteReq
 */
export const SignUp_ViaSalesmanInviteReq = proto3.makeMessageType(
  "com.diagnocat.auth.SignUp_ViaSalesmanInviteReq",
  () => [
    { no: 1, name: "InviteToken", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "Password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.Recover_ByEmail_1_StartReq
 */
export const Recover_ByEmail_1_StartReq = proto3.makeMessageType(
  "com.diagnocat.auth.Recover_ByEmail_1_StartReq",
  () => [
    { no: 1, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.Recover_ByEmail_2_SetPasswordReq
 */
export const Recover_ByEmail_2_SetPasswordReq = proto3.makeMessageType(
  "com.diagnocat.auth.Recover_ByEmail_2_SetPasswordReq",
  () => [
    { no: 1, name: "Token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "TOTPCode", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Factor" },
    { no: 4, name: "RecoveryCode", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Factor" },
  ],
);

/**
 * @generated from message com.diagnocat.auth.PasswordPolicy_GetReq
 */
export const PasswordPolicy_GetReq = proto3.makeMessageType(
  "com.diagnocat.auth.PasswordPolicy_GetReq",
  () => [
    { no: 1, name: "Token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.PasswordPolicy_GetResp
 */
export const PasswordPolicy_GetResp = proto3.makeMessageType(
  "com.diagnocat.auth.PasswordPolicy_GetResp",
  () => [
    { no: 1, name: "MinLength", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "MaxLength", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "MFARequired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.LogoutReq
 */
export const LogoutReq = proto3.makeMessageType(
  "com.diagnocat.auth.LogoutReq",
  () => [
    { no: 1, name: "Option", kind: "enum", T: proto3.getEnumType(LogoutReq_LogoutOption) },
  ],
);

/**
 * @generated from enum com.diagnocat.auth.LogoutReq.LogoutOption
 */
export const LogoutReq_LogoutOption = proto3.makeEnum(
  "com.diagnocat.auth.LogoutReq.LogoutOption",
  [
    {no: 0, name: "None"},
    {no: 1, name: "SteppedAway"},
    {no: 2, name: "LogoutEverywhere"},
  ],
);

/**
 * @generated from message com.diagnocat.auth.RefreshResp
 */
export const RefreshResp = proto3.makeMessageType(
  "com.diagnocat.auth.RefreshResp",
  () => [
    { no: 1, name: "OK", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "AccessTokenTTL", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "RefreshTokenTTL", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.GetTTLsResp
 */
export const GetTTLsResp = proto3.makeMessageType(
  "com.diagnocat.auth.GetTTLsResp",
  () => [
    { no: 1, name: "AccessTokenTTL", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "RefreshTokenTTL", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.OrganizationAPIKey_ListReq
 */
export const OrganizationAPIKey_ListReq = proto3.makeMessageType(
  "com.diagnocat.auth.OrganizationAPIKey_ListReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.OrganizationAPIKey_ListResp
 */
export const OrganizationAPIKey_ListResp = proto3.makeMessageType(
  "com.diagnocat.auth.OrganizationAPIKey_ListResp",
  () => [
    { no: 1, name: "APIKeys", kind: "message", T: OrganizationAPIKey, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.auth.OrganizationAPIKey_CreateReq
 */
export const OrganizationAPIKey_CreateReq = proto3.makeMessageType(
  "com.diagnocat.auth.OrganizationAPIKey_CreateReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ExpiresAt", kind: "message", T: Timestamp },
    { no: 3, name: "Comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.OrganizationAPIKey_CreateResp
 */
export const OrganizationAPIKey_CreateResp = proto3.makeMessageType(
  "com.diagnocat.auth.OrganizationAPIKey_CreateResp",
  () => [
    { no: 1, name: "APIKey", kind: "message", T: OrganizationAPIKey },
  ],
);

/**
 * @generated from message com.diagnocat.auth.OrganizationAPIKey_DeleteReq
 */
export const OrganizationAPIKey_DeleteReq = proto3.makeMessageType(
  "com.diagnocat.auth.OrganizationAPIKey_DeleteReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.OrganizationAPIKey_DeleteResp
 */
export const OrganizationAPIKey_DeleteResp = proto3.makeMessageType(
  "com.diagnocat.auth.OrganizationAPIKey_DeleteResp",
  [],
);

/**
 * @generated from message com.diagnocat.auth.UserPermissions_GetReq
 */
export const UserPermissions_GetReq = proto3.makeMessageType(
  "com.diagnocat.auth.UserPermissions_GetReq",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.UserPermissions_GetResp
 */
export const UserPermissions_GetResp = proto3.makeMessageType(
  "com.diagnocat.auth.UserPermissions_GetResp",
  () => [
    { no: 1, name: "Permissions", kind: "message", T: Permissions },
  ],
);

/**
 * @generated from message com.diagnocat.auth.UserPermissions_SetReq
 */
export const UserPermissions_SetReq = proto3.makeMessageType(
  "com.diagnocat.auth.UserPermissions_SetReq",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Permissions", kind: "message", T: Permissions },
  ],
);

/**
 * @generated from message com.diagnocat.auth.UserPermissions_SetResp
 */
export const UserPermissions_SetResp = proto3.makeMessageType(
  "com.diagnocat.auth.UserPermissions_SetResp",
  () => [
    { no: 1, name: "Permissions", kind: "message", T: Permissions },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_Enroll_BeginReq
 */
export const MFA_Enroll_BeginReq = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_Enroll_BeginReq",
  () => [
    { no: 1, name: "CurrentCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_Enroll_BeginResp
 */
export const MFA_Enroll_BeginResp = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_Enroll_BeginResp",
  () => [
    { no: 1, name: "Secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OtpauthURI", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_Enroll_ConfirmReq
 */
export const MFA_Enroll_ConfirmReq = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_Enroll_ConfirmReq",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_Enroll_ConfirmResp
 */
export const MFA_Enroll_ConfirmResp = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_Enroll_ConfirmResp",
  () => [
    { no: 1, name: "RecoveryCodes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "SignInRequired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_SignIn_VerifyReq
 */
export const MFA_SignIn_VerifyReq = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_SignIn_VerifyReq",
  () => [
    { no: 1, name: "TOTPCode", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Factor" },
    { no: 2, name: "RecoveryCode", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Factor" },
  ],
);

/**
 * @generated from message com.diagnocat.auth.MFA_DisableReq
 */
export const MFA_DisableReq = proto3.makeMessageType(
  "com.diagnocat.auth.MFA_DisableReq",
  () => [
    { no: 1, name: "CurrentCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.AdminMFA_UserReq
 */
export const AdminMFA_UserReq = proto3.makeMessageType(
  "com.diagnocat.auth.AdminMFA_UserReq",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.AdminMFA_StatusResp
 */
export const AdminMFA_StatusResp = proto3.makeMessageType(
  "com.diagnocat.auth.AdminMFA_StatusResp",
  () => [
    { no: 1, name: "Status", kind: "message", T: MFAStatus },
  ],
);

/**
 * @generated from message com.diagnocat.auth.AdminMFA_EnforceReq
 */
export const AdminMFA_EnforceReq = proto3.makeMessageType(
  "com.diagnocat.auth.AdminMFA_EnforceReq",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Enforced", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.Sessions_StaffMember
 */
export const Sessions_StaffMember = proto3.makeMessageType(
  "com.diagnocat.auth.Sessions_StaffMember",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.Sessions_ListReq
 */
export const Sessions_ListReq = proto3.makeMessageType(
  "com.diagnocat.auth.Sessions_ListReq",
  () => [
    { no: 1, name: "Me", kind: "message", T: Empty, oneof: "Owner" },
    { no: 2, name: "Staff", kind: "message", T: Sessions_StaffMember, oneof: "Owner" },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.Sessions_ListResp
 */
export const Sessions_ListResp = proto3.makeMessageType(
  "com.diagnocat.auth.Sessions_ListResp",
  () => [
    { no: 1, name: "Sessions", kind: "message", T: Session, repeated: true },
    { no: 2, name: "Total", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.Sessions_RevokeReq
 */
export const Sessions_RevokeReq = proto3.makeMessageType(
  "com.diagnocat.auth.Sessions_RevokeReq",
  () => [
    { no: 1, name: "SessionID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Target" },
    { no: 2, name: "All", kind: "message", T: Empty, oneof: "Target" },
    { no: 3, name: "Me", kind: "message", T: Empty, oneof: "Owner" },
    { no: 4, name: "Staff", kind: "message", T: Sessions_StaffMember, oneof: "Owner" },
  ],
);

/**
 * @generated from message com.diagnocat.auth.StaffMFA_Req
 */
export const StaffMFA_Req = proto3.makeMessageType(
  "com.diagnocat.auth.StaffMFA_Req",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.auth.StaffMFA_StatusResp
 */
export const StaffMFA_StatusResp = proto3.makeMessageType(
  "com.diagnocat.auth.StaffMFA_StatusResp",
  () => [
    { no: 1, name: "Enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "SetupAt", kind: "message", T: Timestamp },
  ],
);

